import {
    PRODUCT_SUBMIT_PRO_LNGLIST_BEGIN,
    PRODUCT_SUBMIT_PRO_LNGLIST_SUCCESS,
    PRODUCT_SUBMIT_PRO_LNGLIST_FAILURE,
    PRODUCT_SUBMIT_PRO_LNGLIST_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitPro_lnglist(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: PRODUCT_SUBMIT_PRO_LNGLIST_BEGIN,
      });
  

    const promise = new Promise((resolve, reject) => {
      console.log(params)
        request({
          method:'PUT',
          url:'/api/gc/product/lng',
          data: params,
        }).then( data => {
            dispatch({
                type: PRODUCT_SUBMIT_PRO_LNGLIST_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: PRODUCT_SUBMIT_PRO_LNGLIST_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitPro_lnglistError() {
    return {
      type: PRODUCT_SUBMIT_PRO_LNGLIST_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case PRODUCT_SUBMIT_PRO_LNGLIST_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitPro_lnglistPending: true,
          submitPro_lnglistError: null,
        };
  
      case PRODUCT_SUBMIT_PRO_LNGLIST_SUCCESS:
        // The request is success
        return {
          ...state,
          submitPro_lnglistPending: false,
          submitPro_lnglistError: null,
        };
  
      case PRODUCT_SUBMIT_PRO_LNGLIST_FAILURE:
        // The request is failed
        return {
          ...state,
          submitPro_lnglistPending: false,
          submitPro_lnglistError: action.data.error,
        };
  
      case PRODUCT_SUBMIT_PRO_LNGLIST_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitPro_lnglistError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/product/redux/submitPro_lnglist.js